export default __webpack_public_path__ + "static/media/Gilroy-Regular.b91b0127.ttf";